import React from 'react';
import { Stack } from '@mui/material';
import { InputField } from 'components/form';
import { useFormContext } from 'react-hook-form';
import { LenderDeskingPanelFormValues } from '../../../types';

export const LenderDescriptionSection = () => {
  const { control } = useFormContext<LenderDeskingPanelFormValues>();

  return (
    <Stack gap="1rem">
      <InputField
        control={control}
        label="Description"
        name="lenderDescription"
        inputProps={{
          minRows: 4,
          maxRows: 4,
          disabled: true,
          multiline: true,
          required: true,
          variant: 'outlined',
        }}
      />
    </Stack>
  );
};
